export default "Museum Obscurum is an exhibition at Museum Lolland-Falster that opened in October 2017, the escape room was added in early 2019. ";